<template>
  <div>
    <div class="row">
      <!-- Tabel Tunggakan-->
      <div class="col-lg-12">
        <div class="dx-card px-3 py-4 mt-3">
          <div style="height: calc(100vh - 200px);">
            <DxDataGrid
                :dataSource="userManagementStore.userDataSource"
                height="100%"
                @editing-start="userManagementStore.onEditingStart"
                @init-new-row="userManagementStore.onInitNewRow"
                :showBorders="true"
                :remoteOperations="{ filtering: true, sorting: true, paging: true }"
            >
              <DxEditing
                  mode="popup"
                  :allowUpdating="true"
                  :allowDeleting="true"
                  :allowAdding="true"
              >
                <DxPopup title="User" :showTitle="true"/>
                <DxForm>
                  <DxItem
                      dataField="name"
                      :editorOptions="{ showClearButton: true }"
                  />
                  <DxItem
                      dataField="email"
                      :editorOptions="{ showClearButton: true }"
                  />
                  <!-- Branch SelectBox -->
                  <DxItem dataField="branch_id" caption="Branch"></DxItem>

                  <!-- Role SelectBox -->
                  <DxItem dataField="role_id" caption="Role"></DxItem>
                  <!-- Password fields for new user or changing password -->
                  <DxItem dataField="password" editorType="dxTextBox">
                    <DxTextBox v-model:value="userStore.selectedPassword" mode="password" placeholder="Password"/>
                  </DxItem>

                  <DxItem dataField="confirmPassword" editorType="dxTextBox"
                          :editorOptions="{ mode: 'password', placeholder: 'Confirm Password' }">
                    <DxCompareRule message="Passwords do not match"
                                   :comparisonTarget="userManagementStore.getPasswordComparison"/>
                  </DxItem>
                </DxForm>
              </DxEditing>
              <DxColumn dataField="name" caption="Name"/>
              <DxColumn dataField="email" caption="Email"/>
              <DxColumn dataField="branch_id" caption="Cabang">
                <DxLookup
                    :dataSource="userManagementStore.branchesDataSource"
                    valueExpr="id"
                    displayExpr="name"
                />
              </DxColumn>
              <DxColumn dataField="role_id" caption="Hak Akses">
                <DxLookup
                    :dataSource="userManagementStore.rolesDataSource"
                    valueExpr="id"
                    displayExpr="name"
                />
              </DxColumn>
              <DxColumn type="buttons" width="110">
                <DxButton name="edit"/>
                <DxButton name="delete"/>
              </DxColumn>

              <DxPager :visible="true" :showPageSizeSelector="true" :allowedPageSizes="[5, 10, 20]" :showInfo="true"/>
              <DxPaging :enabled="true" :defaultPageSize="10"/>
              <DxFilterRow :visible="true"/>
              <DxHeaderFilter :visible="false"/>
              <DxSorting mode="single"/>
            </DxDataGrid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import DxDataGrid, {
  DxColumn,
  DxEditing,
  DxPopup,
  DxForm,
  DxItem,
  DxPager,
  DxPaging,
  DxFilterRow,
  DxHeaderFilter,
  DxSorting,
  DxButton,
  DxLookup,
} from 'devextreme-vue/data-grid';

//import {DxSelectBox} from "devextreme-vue/select-box"
import {DxTextBox} from "devextreme-vue/text-box";
import {DxCompareRule} from 'devextreme-vue/form';

import {useUserManagementStore} from '@/store/views/user-management-store';
import {useUserStore} from "@/store/models/user-store";
import { onMounted } from 'vue';

const userManagementStore = useUserManagementStore();
const userStore = useUserStore();

onMounted(() => {
  userManagementStore.initialize();
});

</script>

<style lang="scss">
</style>
